class CollectionFilters extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('#FacetFiltersForm');
    this.sortForm = this.querySelector('#SortForm');
    this.grid = this.querySelector('[data-product-grid]');
    this.filtersToggle = this.querySelector('[data-filters-toggle]');
    this.filtersPanel = this.querySelector('#CollectionFilters');

    this.bindFacetInputs();
    this.bindSort();
    this.bindViewToggle();
    this.bindFiltersToggle();
  }

  bindFacetInputs() {
    if (!this.form) return;
    this.form.addEventListener('change', (event) => {
      if (event.target.matches('[data-facet-checkbox]') || event.target.matches('[data-facet-input]')) {
        this.form.requestSubmit();
      }
    });
  }

  bindSort() {
    const select = this.querySelector('[data-sort-select]');
    if (!select || !this.sortForm) return;
    select.addEventListener('change', () => {
      this.sortForm.requestSubmit();
    });
  }

  bindViewToggle() {
    const buttons = this.querySelectorAll('[data-view-toggle]');
    if (!buttons.length || !this.grid) return;

    const stored = window.localStorage.getItem('collection-view');
    if (stored === 'list') {
      this.setView('list', buttons);
    }

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const view = button.dataset.viewToggle;
        this.setView(view, buttons);
        window.localStorage.setItem('collection-view', view);
      });
    });
  }

  setView(view, buttons) {
    this.grid.classList.toggle('collection__products--list', view === 'list');
    buttons.forEach((button) => {
      const isActive = button.dataset.viewToggle === view;
      button.classList.toggle('collection__view-button--active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  bindFiltersToggle() {
    if (!this.filtersToggle || !this.filtersPanel) return;
    this.filtersToggle.hidden = false;
    this.filtersToggle.addEventListener('click', () => {
      this.filtersPanel.classList.toggle('collection__filters--open');
    });
  }
}

customElements.define('collection-filters', CollectionFilters);
